export default function getLanguageNameFromLanguageCode(
  languageCode: string,
): string {
  const intl = new Intl.DisplayNames([languageCode], {
    type: 'language',
  })

  return intl.of(languageCode)
}
